import React from "react";

const OldVehicleCar = () => {
  //old_products

  return (
    <div>
      <h1>Old Car Model Part</h1>
    </div>
  );
};

export default OldVehicleCar;
